<template>
  <transition name="fade">
    <div
      class="image-preview"
      @click="$emit('close')"
    >
      <div
        id="image-preview-popup"
        class="close-btn"
        @click="$emit('close')"
        data-shortcut-esc="imagePreview"
      >
        <span></span>
      </div>
      <div class="wrapper">
        <div
          v-if="isLoading"
          class="spinner"
        >
          <span>Loading...</span>
        </div>
        <img
          :class="{ loaded: !isLoading }"
          :src="url"
          ref="image"
        />
      </div>
    </div>
  </transition>
</template>
<script>
import ShortCutBase from '@/mixins/ShortCutBase'

export default {
  props: [
    'imageId',
  ],
  mixins: [
    ShortCutBase
  ],
  data () {
    return {
      url: null,
      isLoading: true,
    }
  },
  computed: {
    maxWidth () {
      return this.$store.getters.noUnitScssVars.imagePreviewMaxWidth
    },
    maxHeight () {
      return this.$store.getters.noUnitScssVars.imagePreviewMaxHeight
    }
  },
  async mounted () {
    // スクロール禁止
    const img = this.$refs.image
    img.addEventListener('load', () => {
      const ratio = img.width / img.height
      if (img.width - img.height > 0) {
        if (img.width > this.maxWidth) {
          // 指定サイズ内に収める
          img.width = this.maxWidth
          img.height = img.width / ratio
          if (img.height > this.maxHeight) {
            img.height = this.maxHeight
            img.width = img.height * ratio
          }
        }
      } else {
        if (img.height > this.maxHeight) {
          // 指定サイズ内に収める
          img.height = this.maxHeight
          img.width = img.height * ratio
          if (img.width > this.maxWidth) {
            img.width = this.maxWidth
            img.height = img.width / ratio
          }
        }
      }
      this.isLoading = false
    })
    document.addEventListener('mousewheel', this.handleEvent, { passive: false })
    document.addEventListener('touchmove', this.handleEvent, { passive: false })

    const json = await this.$http({
      url: `/image/${this.imageId}`,
      type: 'GET',
    })
    if (json && json.status === 200) {
      this.url = decodeURIComponent(json.data.url)
    }
  },
  beforeDestroy () {
    // スクロール復帰
    document.removeEventListener('mousewheel', this.handleEvent, { passive: false })
    document.removeEventListener('touchmove', this.handleEvent, { passive: false })
  },
  methods: {
    handleEvent (event) {
      event.preventDefault()
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/scss/app/_full-screen-modal.scss";
.image-preview {
  @extend .full-screen-modal;
  z-index: 3000;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  .wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: $imagePreviewMaxWidth;
    height: $imagePreviewMaxHeight;
    background-color: #ffffff;
    img {
      transition: all 0.3s ease 0s;
      opacity: 0;
      display: block;
      &.loaded {
        opacity: 1;
      }
    }
  }
}

#image-preview-popup.close-btn {
  span::before, span::after {
    background: #ffffff;
  }
}
</style>
